export const GMAPS_API_KEY = "AIzaSyAZmy6RhNdiEtZQifMf6SxNLbX8kya0nO4";
export const GPLACE_API_KEY = "AIzaSyAXL8dcfvV6TkIDSTPv0j-2mFGIFmPVHvg";
export const MAILGUN_API_KEY = "0c10b057b11425a17d487517c4e88536-4167c382-ef513820"
export const FOURSQUARE_CLIENT_ID = "GPISP5UQKDZR4HPFYJ2HTZHWUDT5VKFWZ2QIWK4RZ25QHFC2";
export const FOURSQUARE_CLIENT_SECRET = "RF34LWVTZ1TCJ5RHCAHASNFPXVWK31V5DOO1HTC4MDIAWCXA";